import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { _init_without_token_api, _auth_api } from "../../../DAL/Login/Login";
import { useAdminContext } from "../../../hooks/UseAdminContext";
import { allowedDomains } from "../../../hooks/allowedDomains";
import AuthPrompt from "../../dialogs/AuthPrompt";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function LogoOnlyLayout() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const {
    setAdminSetting,
    setIsOpenAuthModal,
    isAuthenticated,
    setIsAuthenticated,
  } = useAdminContext();

  const get_setting_data = async () => {
    const result = await _init_without_token_api();
    if (result.code === 200) {
      setAdminSetting(result?.maintenance_settings);
      setIsLoading(false);
      if (
        result?.maintenance_settings?.enable_developer_auth &&
        allowedDomains.includes(window.location.hostname)
      ) {
        // Only Show Auth Prompt if not already authenticated in this session
        if (sessionStorage.getItem("is_authenticated") === "true") {
          setIsAuthenticated(true);
        } else {
          setIsOpenAuthModal(true);
        }
      } else {
        setIsAuthenticated(true);
      }

      if (result?.maintenance_settings?.enable_maintenace_mode) {
        navigate("/under-maintenance", { replace: true });
      }
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    get_setting_data();
  }, []);

  if (localStorage.getItem("code-verified")) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return <>{isAuthenticated ? <Outlet /> : <AuthPrompt />}</>;
}
